export const indianArtStars = [
  {
    slug: 'santosh-kumar-sandilya',
    name: 'Santosh Kumar Sandilya',
    knownAs: 'Sandilya',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    regionLabel: 'Varanasi, Uttar Pradesh',
    category: 'Painter',
    specialty: 'Ganga-inspired landscapes and Varanasi heritage paintings',
    heading: 'Stars of Indian Art',
    eyebrow: 'Managed by KalaManch Admin',
    shortIntro:
      'A distinguished Varanasi artist whose paintings carry the spiritual rhythm of the ghats, the Ganga, and the cultural memory of Banaras.',
    profilePath: '/artist/santosh-kumar-sandilya-painter-varanasi',
    facebookUrl: 'https://www.facebook.com/artistsantosh1',
    externalWebsite: 'https://sandilyaarts.com/',
    secondaryWebsite: 'https://www.santoshkumarsandilya.art',
    portfolioVideoUrls: [
      'https://www.youtube.com/watch?v=7RNRD1OKXro',
      'https://www.facebook.com/reel/990172907263304',
    ],
    portrait: '/images/indian-art/santosh-kumar-sandilya/portrait.jpg',
    coverArtwork: '/images/indian-art/santosh-kumar-sandilya/artwork-5.png',
    artworks: [
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-1.png', title: 'Ghat geometry and sacred stillness' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-2.png', title: 'Boats, reflections, and river life' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-3.png', title: 'Temple skyline of Banaras' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-4.png', title: 'People, water, and lived ritual' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-5.png', title: 'Varanasi panorama with river movement' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-6.png', title: 'Ritual smoke and sacred evening offering' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-7.png', title: 'Temple interior opening to the riverfront' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-8.png', title: 'Long river edge and layered Banaras skyline' },
      { src: '/images/indian-art/santosh-kumar-sandilya/artwork-9.png', title: 'Priests, incense, and luminous ceremony' },
    ],
    heroBadges: ['Performance Verified on KalaManch', 'Featured Artist', 'Admin Curated'],
    bioParagraphs: [
      'Santosh Kumar Sandilya, popularly known as Sandilya, is a distinguished artist based in the sacred city of Varanasi. Deeply inspired by the timeless beauty and spirituality of the city, especially its iconic ghats and the holy Ganga river, his artworks capture the soul and cultural heritage of Banaras.',
      'One of the most striking aspects of his practice is the way he incorporates the sacred water of the Ganga into his creative process. That gesture turns his landscapes into something more than scenic paintings; they become artistic offerings that carry devotion, memory, and place together.',
      'Through his canvases, Santosh continues to celebrate and promote the spiritual essence of Varanasi, preserving the atmosphere of its riverbanks, rituals, boats, temples, and lived cultural rhythm in a form that can travel far beyond the city itself.',
    ],
    profileHighlights: [
      'Based in Varanasi and widely known for Ganga and ghat-inspired visual storytelling',
      'Graduate and postgraduate in Fine Arts from Banaras Hindu University',
      'Nature Landscape specialization shaped under the Fine Arts tradition of BHU',
      'Artist, educator, workshop mentor, and live demonstrator',
      'Works collected nationally and internationally',
    ],
    education: [
      'Formal graduation and postgraduation in Fine Arts from Banaras Hindu University, Lalit Kala Department',
      'Nature Landscape specialization shaped under the guidance of teachers including Dr. Ravindra Nath Mishra',
      'Additional exposure through NCC training, yoga studies, and photography learning',
    ],
    career: [
      'Has taught art in respected institutions including DAV and DPS',
      'Currently associated with the Government of Uttar Pradesh',
      'Mentors younger artists through workshops, demonstrations, and art education activities',
      'Has served as Secretary of the Banaras Art and Craft Development Society and Director of Sandilya Arts',
    ],
    exhibitions: [
      'Solo shows and art walks connected with The Oberoi Hotel Mumbai',
      'Participation in major exhibitions, workshops, camps, and gallery shows across India',
      'International presence including Gwangju International Art Fair, South Korea',
      'Recent visibility in Mumbai, Varanasi, Shimla, Gandhidham, West Bengal, and other art circuits',
    ],
    recognition: [
      'Recipient of multiple awards and recognitions, including honours from Bihar Government cultural circles and Prachin Kala Kendra, Chandigarh',
      'Artworks held in over 300 national and 38 international collections',
      'Includes a noted collection associated with former Petroleum Minister Hardeep Singh Puri',
    ],
    curatorialNote:
      'KalaManch is beginning this series with Santosh Kumar Sandilya because his work stands at the meeting point of Indian heritage, lived spirituality, and visual craft. This is the kind of artist page that can grow into a permanent KalaManch showcase for star artists of India.',
  },
  {
    slug: 'chandani-vishwakarma',
    name: 'Chandani Vishwakarma',
    knownAs: 'Banarasi Ki Rangoli',
    city: 'Varanasi',
    state: 'Uttar Pradesh',
    regionLabel: 'Kashi / Varanasi, Uttar Pradesh',
    category: 'Rangoli Art',
    specialty: 'Traditional Rangoli Artist rooted in Banaras celebration and ceremony',
    heading: 'Stars of Indian Art',
    eyebrow: 'Managed by KalaManch Admin',
    shortIntro:
      'A Varanasi-based rangoli artist whose work turns ceremonial floor design into a vivid public art form across weddings, festivals, and culturally rooted spaces.',
    profilePath: '/artist/chandani-vishwakarma-rangoli-art-varanasi',
    instagramUrl: 'https://www.instagram.com/banarasi_ki_rangoli/',
    youtubeUrl: 'https://www.youtube.com/@chandanivishwa1432',
    facebookUrl: 'https://www.facebook.com/profile.php?id=100090156480002&mibextid=ZbWKwL&utm_source=ig&utm_medium=social&utm_content=link_in_bio',
    portrait: 'https://res.cloudinary.com/dydjauztz/image/upload/v1776663189/kalamanch/profile-images/profile-4bc863e5aebc.jpg',
    coverArtwork: '/images/indian-art/chandani-vishwakarma/artwork-1.jpg',
    artworks: [
      { src: '/images/indian-art/chandani-vishwakarma/artwork-1.jpg', title: 'Banaras-inspired festive rangoli composition' },
      { src: '/images/indian-art/chandani-vishwakarma/artwork-2.png', title: 'Ceremonial rangoli for wedding and celebration spaces' },
      { src: '/images/indian-art/chandani-vishwakarma/artwork-3.png', title: 'Traditional colour-led rangoli detail work' },
      { src: '/images/indian-art/chandani-vishwakarma/banarasi-ki-rangoli.png', title: 'Banarasi Ki Rangoli devotional floor artwork showcase' },
    ],
    portfolioVideoUrls: [
      'https://www.youtube.com/watch?v=JvN5mN7-Tc8',
      'https://www.youtube.com/watch?v=3KmSx6tpnqc',
    ],
    heroBadges: ['Verified Profile', 'Admin Curated', 'Traditional Rangoli'],
    bioParagraphs: [
      'Chandani Vishwakarma is a talented rangoli artist known for creating vibrant, intricate, and culturally rich rangoli designs that add beauty and elegance to every celebration. Inspired by Indian traditions and the spiritual heritage of Banaras, her work blends creativity with cultural significance.',
      'From grand wedding celebrations and festive occasions to traditional ceremonies and themed events, Chandani specializes in customized rangoli artworks that leave a lasting impression. Her work spans both traditional and contemporary styles using colour powders, acrylics, and hand-crafted artistic techniques.',
      'KalaManch is featuring Chandani in Stars of Indian Art because rangoli deserves the same level of digital visibility as canvas-based fine art. Her page helps position traditional floor art not as background decoration, but as a living Indian visual practice with its own skill, identity, and artist authorship.',
    ],
    profileHighlights: [
      'Traditional rangoli artist based in Varanasi / Kashi',
      'Creates customized rangoli for weddings, haldi functions, festivals, and cultural events',
      'Works across colour-powder, acrylic, theme-based, and ceremonial rangoli design',
      'Featured in KalaManch curated Indian traditional art showcase',
    ],
    education: [
      'Artist profile is rooted in lived traditional practice rather than a formal academic fine-art route.',
      'Work reflects strong familiarity with Banaras festive culture, ceremonial layouts, and culturally meaningful design motifs.',
      'KalaManch can continue expanding this section as more approved artist notes and documented milestones are added.',
    ],
    career: [
      'Designs rangoli installations for festive occasions, wedding spaces, haldi ceremonies, and cultural programs.',
      'Builds both traditional and contemporary compositions depending on event mood, venue, and theme.',
      'Maintains a public creative presence through KalaManch, YouTube, Instagram, and Facebook-linked portfolio channels.',
    ],
    exhibitions: [
      'Current KalaManch star page showcases approved rangoli portfolio selections from her public artist record.',
      'Video portfolio links highlight the presentation side of her work beyond still images.',
      'This curated page gives rangoli practice a gallery-style home inside KalaManch broader Indian art discovery layer.',
    ],
    recognition: [
      'Curated into Stars of Indian Art on KalaManch for traditional rangoli visibility.',
      'Public trust status on KalaManch currently shows Verified Profile.',
      'Selected as part of KalaManch effort to give stronger digital space to traditional Indian art forms.',
    ],
    curatorialNote:
      'Chandani page is a strong example of why KalaManch is building Stars of Indian Art as a series. Rangoli is widely practiced and deeply respected, but it rarely gets the same structured digital presentation given to studio painting. This feature begins correcting that gap with a proper curated artist page.',
  },
  {
    slug: 'pottery-station-ramgarh',
    name: 'Ishver Singh',
    knownAs: 'Pottery Station Ramgarh',
    city: 'Ramgarh',
    state: 'Jharkhand',
    regionLabel: 'Ramgarh, Jharkhand',
    category: 'Craft Artist',
    specialty: 'Terracotta, Kagaji pottery, and heirloom pottery traditions from Ramgarh',
    heading: 'Stars of Indian Art',
    eyebrow: 'Managed by KalaManch Admin',
    shortIntro:
      'A traditional pottery artist carrying forward a rare family lineage of Kagaji pottery and terracotta practice from Ramgarh, where every piece holds both utility and cultural memory.',
    profilePath: '/artist/ishver-singh-craft-artist-ramgarh',
    instagramUrl: 'https://www.instagram.com/pottery_station_ramgarh/',
    portrait: 'https://res.cloudinary.com/dydjauztz/image/upload/v1781066448/kalamanch/profile-images/profile-8a69c0b8071d.jpg',
    coverArtwork: '/images/indian-art/pottery-station-ramgarh/artwork-1.png',
    artworks: [
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-1.png', title: 'Handmade pottery form from the Ramgarh studio line' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-2.png', title: 'Terracotta and clay craftsmanship shaped through family practice' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-3.png', title: 'Kagaji pottery tradition presented as living Indian craft' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-4.png', title: 'Wheel-thrown clay form shaped by hand in motion' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-5.png', title: 'Ramgarh studio collection of terracotta vessels and handcraft objects' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-6.png', title: 'Detail view of handcrafted clay vessel shaping' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-7.png', title: 'Artist at the wheel continuing a generational pottery practice' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-8.png', title: 'Minimal clay wall piece with sculptural face motif' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-9.png', title: 'Hand-etched wheat motif developed in wet clay' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-10.png', title: 'Terracotta bird vessels and decorative pottery wall installation' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-11.png', title: 'Fired pottery bottle series in earthy black and red finishes' },
      { src: '/images/indian-art/pottery-station-ramgarh/artwork-12.png', title: 'Large vessel making shown beside a finished design reference' },
    ],
    portfolioVideoUrls: [
      'https://www.youtube.com/shorts/mxy5WhvMSV4',
      'https://www.youtube.com/shorts/l2nqKGQ9SSM',
    ],
    heroBadges: ['Verified Profile', 'Admin Curated', 'Traditional Pottery'],
    bioParagraphs: [
      'Ishver Singh represents a deeply rooted pottery lineage from Ramgarh. His family has been involved in the traditional art of pottery for nearly fifteen generations, preserving a rare craft inheritance that is still practiced with commitment and pride.',
      'The family is regarded as one of the only heirloom-class lineages in India producing Kagaji Pottery. This is not simply a studio practice or decorative hobby; it is a cultural inheritance passed across generations and sustained through dedicated making.',
      'KalaManch is featuring Pottery Station Ramgarh in Stars of Indian Art to give terracotta, clay, and craft traditions the same narrative visibility often reserved for urban gallery forms. The page places artisanal process, family lineage, and regional memory at the center of the story.',
    ],
    profileHighlights: [
      '15th-generation pottery artist continuing a family craft tradition',
      'Known for Kagaji pottery, terracotta work, and hand-built clay practice',
      'Represents Ramgarh traditional pottery as living Indian heritage',
      'Featured by KalaManch as part of a broader traditional art discovery series',
    ],
    education: [
      'Primary training comes through intergenerational family practice rather than formal institutional schooling.',
      'Technical knowledge includes clay preparation, hand-building, carving, firing, and finishing shaped over generations.',
      'KalaManch can expand this section later with more documented workshop and lineage notes.',
    ],
    career: [
      'Carries forward a family pottery line with focus on preserving traditional Indian clay craft.',
      'Works across functional, decorative, and heirloom terracotta and pottery objects.',
      'Uses KalaManch to position regional pottery as a discoverable artist-led practice rather than only a commodity craft.',
    ],
    exhibitions: [
      'Current curated page highlights approved pottery images from the public KalaManch profile.',
      'YouTube short-form videos help audiences see the living nature of the work beyond still images.',
      'This page is the start of a fuller KalaManch archive for rare Indian pottery lineages and craft studios.',
    ],
    recognition: [
      'Featured in Stars of Indian Art for preserving Kagaji pottery and Ramgarh clay craft traditions.',
      'KalaManch public trust status currently shows Verified Profile.',
      'Recognized in this series for the cultural importance of lineage-based Indian craft work.',
    ],
    curatorialNote:
      'Pottery Station Ramgarh strengthens the idea behind this whole series: not every important Indian artist belongs to a mainstream gallery pipeline. Some belong to family workshops, village-to-city craft routes, and inherited material traditions that deserve the same digital dignity and archival care.',
  },
];

export const indianArtStarsBySlug = indianArtStars.reduce((accumulator, star) => {
  accumulator[star.slug] = star;
  return accumulator;
}, {});

const normalizeText = (value = '') =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/[^a-z0-9 ]+/g, '');

const slugTail = (path = '') => String(path || '').split('/').filter(Boolean).pop() || '';

export const findIndianArtStarForArtist = (artist = {}) => {
  const artistSlug = String(artist.slug || '').trim();
  const normalizedName = normalizeText(artist.name);
  const normalizedCity = normalizeText(artist.city);

  return indianArtStars.find((star) => {
    const starProfileSlug = slugTail(star.profilePath);
    if (artistSlug && starProfileSlug && artistSlug === starProfileSlug) return true;
    return normalizeText(star.name) === normalizedName && normalizeText(star.city) === normalizedCity;
  }) || null;
};

export const resolveIndianArtStarMarker = (artist = {}) => {
  const slug = String(artist.indian_art_star_slug || '').trim();
  const url = String(artist.indian_art_star_url || '').trim();
  const title = String(artist.indian_art_star_title || '').trim() || 'Star of Indian Art';

  if (slug || url) {
    return {
      slug: slug || slugTail(url),
      url: url || `/indian-art/stars/${slug}`,
      title,
      source: 'backend',
    };
  }

  const fallback = findIndianArtStarForArtist(artist);
  if (!fallback) return null;
  return {
    slug: fallback.slug,
    url: `/indian-art/stars/${fallback.slug}`,
    title: fallback.star_title || fallback.heading || 'Star of Indian Art',
    source: 'fallback',
  };
};
